<fcom-modal
  [(open)]="activationModalOpen"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [title]="'CORPORATE.corporatePortal.widgets.safWidget.activateModalTitle' | finLocalization"
  [titleClasses]="'ps-large'"
  [confirmTranslationKey]="'CORPORATE.corporatePortal.widgets.safWidget.activateButton'"
  [closeOnContinue]="false"
  [fitToContent]="true"
  (confirm)="activate()"
  (close)="completed.emit()"
>
  <div class="ps-large">
    <div class="flex text-content">
      <div class="fill--50 ps-xxlarge-r">
        <fcom-icon class="icon-xlarge" [name]="SvgLibraryIcon.SUSTAINABILITY_BLOCK"></fcom-icon>
        <h5 class="font-heading-5 ms-large-y">
          {{ 'CORPORATE.corporatePortal.widgets.safWidget.sustainabilityServices' | finLocalization }}
        </h5>
        <span
          class="styled-content"
          [innerHTML]="
            'CORPORATE.corporatePortal.widgets.safWidget.sustainabilityServicesText' | finLocalization | finSafe: 'html'
          "
        ></span>
      </div>
      <div class="fill--50 ps-xxlarge-r">
        <fcom-icon class="icon-xlarge" [name]="SvgLibraryIcon.INFO_BLOCK"></fcom-icon>
        <h5 class="font-heading-5 ms-large-y">
          {{ 'CORPORATE.corporatePortal.widgets.safWidget.howItWorks' | finLocalization }}
        </h5>
        <ul class="font-body-1 medium-type ps-large-l">
          @for (
            option of 'CORPORATE.corporatePortal.widgets.safWidget.howItWorksOptions' | finLocalization;
            track option
          ) {
            <li>{{ option }}</li>
          }
        </ul>
      </div>
    </div>
    <div class="ms-large-t">
      <fcom-checkbox #termsAccepted (change)="termsNotCheckedError = false">
        <span class="font-body-1 medium-type">{{
          'CORPORATE.corporatePortal.widgets.safWidget.acceptTerms.label' | finLocalization
        }}</span>
        <fcom-link [href]="'https://www.finnair.com'" [openInNewTab]="true" [external]="true">
          {{ 'CORPORATE.corporatePortal.widgets.safWidget.acceptTerms.linkText' | finLocalization }}
        </fcom-link>
      </fcom-checkbox>
      @if (termsNotCheckedError) {
        <div class="error-900-text font-body-2 regular-type ps-xsmall-t" #termsError>
          <fcom-icon [name]="SvgLibraryIcon.ALERT_BLOCK" class="icon-medium ms-xsmall-r"></fcom-icon>
          {{ 'CORPORATE.corporatePortal.widgets.safWidget.acceptTerms.required' | finLocalization }}
        </div>
      }
    </div>
  </div>
</fcom-modal>

<fcom-modal
  [(open)]="credentialsModalOpen"
  [buttons]="ModalButtons.CLOSE"
  [title]="'CORPORATE.corporatePortal.widgets.safWidget.credentialsModalTitle' | finLocalization"
  [titleClasses]="'ps-large'"
  [fitToContent]="true"
  (close)="completed.emit()"
>
  <div class="ps-large flex flex--column flex--center">
    <fcom-icon class="icon-xlarge" [name]="SvgLibraryIcon.INFO_BLOCK"></fcom-icon>
    <h4 class="font-heading-5 ms-medium-t">
      {{ 'CORPORATE.corporatePortal.widgets.safWidget.checkYourEmail' | finLocalization }}
    </h4>
    @if (email$ | async; as email) {
      <p class="font-body-1 ms-medium-t">
        {{ 'CORPORATE.corporatePortal.widgets.safWidget.checkYourEmailText' | finLocalization: { email } }}
      </p>
    }
  </div>
</fcom-modal>
